var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24x24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0286 20C18.7429 20 18.5143 19.8857 18.3429 19.7143L14.4 15.7714C13.3143 16.5714 11.9429 17.0286 10.5714 17.0286C6.91429 17.0286 4 14.0571 4 10.5143C4 6.97143 6.91429 4 10.5143 4C14.1143 4 17.0286 6.91429 17.0286 10.5143C17.0286 11.8857 16.5714 13.2571 15.7714 14.3429L19.7143 18.2857C19.8857 18.4571 20 18.7429 20 18.9714C20 19.2 19.8857 19.4857 19.7143 19.6571C19.5429 19.8286 19.2571 20 19.0286 20ZM10.5143 6C8 6 6 8 6 10.5143C6 13.0286 8 15.0286 10.5143 15.0286C12.9714 15.0286 15.0286 13.0286 15.0286 10.5143C15.0286 8 12.9714 6 10.5143 6Z",
    fill: "#1E1E1E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.eedcc1dc772258114199261d6ad50602.svg";
export { ForwardRef as ReactComponent };